/**
 * A logger for Datadog, which gracefully falls back to doing nothing if Datadog
 * logging is not initialized.
 *
 * See datadog-logging.js for the initialization.
 */

/**
 * The key on the window object to access the logger.
 *
 * Please do not use the logger on the window object directly, use the functions
 * below instead.
 *
 * @type {string}
 */
export const BACKEND_KEY = '__ddLogger';

export function logDebug(message, messageContext = {}, error = {}) {
  window[BACKEND_KEY]?.debug(message, messageContext, error);
}

export function logInfo(message, messageContext = {}, error = {}) {
  window[BACKEND_KEY]?.info(message, messageContext, error);
}

export function logWarning(message, messageContext = {}, error = {}) {
  window[BACKEND_KEY]?.warn(message, messageContext, error);
}

export function logError(message, messageContext = {}, error = {}) {
  window[BACKEND_KEY]?.error(message, messageContext, error);
}
